import { AbsoluteSuitsOnCorners } from '@/components/absolute-suits-on-corners'
import { useAuth } from '@/hooks/use-auth'
import { FreeBankrollActionSection } from '@/pages/promotion/components/free-bankroll-action-section'
import { FreeBankrollEntriesSection } from '@/pages/promotion/components/free-bankroll-entries-section'
import { FreeBankrollHeroSection } from '@/pages/promotion/components/free-bankroll-hero-section'
import { FreeBankrollPrizePoolSection } from '@/pages/promotion/components/free-bankroll-prize-pool-section'
import { FreeBankrollRulesSection } from '@/pages/promotion/components/free-bankroll-rules-section'

export const FreeBankrollRoute = () => {
  const { isAuthorized } = useAuth()

  return (
    <div className="flex flex-col">
      <FreeBankrollHeroSection isAuthorized={isAuthorized} />
      <SectionSeparator />
      <FreeBankrollEntriesSection isAuthorized={isAuthorized} />
      <SectionSeparator />
      <FreeBankrollActionSection isAuthorized={isAuthorized} />
      <SectionSeparator />
      <FreeBankrollPrizePoolSection isAuthorized={isAuthorized} />
      <SectionSeparator />
      <FreeBankrollRulesSection />
    </div>
  )
}

const SectionSeparator = () => {
  return (
    <div className="relative block h-[1px] border-t border-dashed border-divider md:hidden">
      <AbsoluteSuitsOnCorners
        top={0}
        translateY="-50%"
      />
    </div>
  )
}
